import 'whatwg-fetch';
import { checkStatus, authorization } from 'actions/utils/fetch_utils';
import { apiBasename } from 'actions/config/api';

export const updateDay = (id, changes) => {
	return fetch(apiBasename + '/day/' + id, authorization({
		method: 'PUT',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify(changes)
	}))
	.then(checkStatus)
	.then((res) => res.json());
};

export const fetchAbsencesOfDay = (id) => {
	return fetch(apiBasename + '/day/' + id + '/absences', authorization())
	.then(checkStatus)
	.then((res) => res.json());
};
